export default __webpack_public_path__ + "static/media/thum7.65c7b17e.jpg";